/**
 * 获取pathName 删除pathName search部分
 * @param location url location
 */
export function getUrlPurePathName(location: Location) {
    const path = `${location.pathname}${location.hash}`;
    const subLen = path.indexOf('?') > 0 ? path.indexOf('?') : path.length;
    return path.replace(location.search, '').substring(0, subLen);
}

// 获取query变量
export function getQueryVariable(queryKey: string) {
    const path = `${location.pathname}${location.hash}`;
    const subLen = path.indexOf('?') > 0 ? path.indexOf('?') : path.length;
    const search = path.substring(Number(subLen) + 1, path.length);
    const vars = search.split('&');
    const obj = {} as any;
    for (const str of vars) {
        const [key, value] = str.split('=');
        obj[key] = value;
    }
    return obj[queryKey];
}

/**
 * 判断是 【公有云管理端】【浦度管理端】【客户端】
 */
export function getProjectType() {
    /**
     * todo 这一块临时解决方案 域名自定义比较多 后期像一个比较好的方案解决
     */
    // 针对公有云
    if (location.hostname.includes('bcetest.baidu.com')
    || location.hostname.includes('console.bce.baidu.com')
    || location.hostname.includes('admin.bceidaas.com')) {
        return 'publicCloudManager';
    }
    // 行业云
    if (location.hostname.startsWith('admin')) {
        return 'secretManager';
    }
    return 'client';
}
